import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-inventory-outlined",
  "use": "icon-inventory-outlined-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" viewBox=\"0 0 12 12\" id=\"icon-inventory-outlined\"><path fill-rule=\"evenodd\" d=\"M2.741.833a.5.5 0 0 0-.409.212L.777 3.25a.5.5 0 0 0-.091.288v7.294a.5.5 0 0 0 .5.5h9.617a.5.5 0 0 0 .5-.5V3.369a.5.5 0 0 0-.103-.303L9.646 1.029a.5.5 0 0 0-.397-.196zm-.68 2.333L3 1.833h6l1.018 1.333zm-.375 1v6.167h8.617V4.166zm1.398 2h3.305v-1H3.084z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol